import { UpdateReason } from 'APP/constants/scroll';
import { PayloadType } from 'APP/model/message/messageModel.types';
import Entities from 'STORE';
import { ImagePayload } from 'STORE/Messages/Message/Payload/ImagePayload/ImagePayload';
import { VideoPayload } from 'STORE/Messages/Message/Payload/VideoPayload/VideoPayload';

interface IAlbumPayloadItemPresenter {
  onClick(): void;
  cancelUpload(): Promise<void>;
  isPlayIcon: boolean | null;
}

interface IAlbumPayloadItemPresenterProps {
  payload: ImagePayload | VideoPayload;
  id: string;
  openGallery(mediaId: string): void;
  isLoading: boolean;
}

export function useAlbumPayloadItemPresenter(
  props: IAlbumPayloadItemPresenterProps
): IAlbumPayloadItemPresenter {
  const presenter = {
    get isPlayIcon(): boolean | null {
      if (props.payload.payloadType === PayloadType.Image) {
        return null;
      }
      return props.payload.uploadProgress === null && !props.isLoading;
    },

    onClick(): void {
      props.openGallery(props.id);
    },

    async cancelUpload(): Promise<void> {
      await props.payload.cancelUploadAndDeleteMessage();
      Entities.ChatStore.setScrollChanged(UpdateReason.EditMessage);
    },
  };

  return presenter;
}
